module.exports = __webpack_public_path__ + "static/media/mascote_02.b2eb1e18.jpg";